
import { log } from "@antv/g2plot/lib/utils";
import { Alert, Button, Col, Collapse, Form, Input, notification, Row, Select, Spin } from "antd"
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { addPatientRoutineDietApi, editPatientRoutineDietApi, listOfDietTimeApi, listOfMealTimeApi, listOfPatientRoutineDietApi, listOfRoutineDietApi, updatePatientRoutineDietApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../config/constant";
import { apiErrorMessage } from "../../../../../services/ApiError";
import { FilterApiData } from "../../../../../services/FilterApiData";
// import { MedicalDetailsContent } from "./MedicalDestailsContent";

export const RoutineDiet = (props) => {
    const { Panel } = Collapse;
    const [form] = Form.useForm();
    const [dietForm] = Form.useForm();

    // the meal pattern caps the preferred meal times: "4 Meal" allows at most 4
    const mealPattern = Form.useWatch('preferred_meal_pattern', dietForm)
    const pickedMealTimes = Form.useWatch('preferred_meal_time', dietForm) || []
    const mealTimeLimit = parseInt(mealPattern, 10) || 0
    const mealTimesFull = mealTimeLimit > 0 && pickedMealTimes.length >= mealTimeLimit
    const { Option } = Select;
    const { id } = useParams()

    const [editDietFormData, setEditDietFormData] = useState({});
    const [DietTimeOptions, setDietTimeOptions] = useState([]);
    const [mealTimeOptions, setMealTimeOptions] = useState([]);
    const [routineDietOptions, setRoutineDietOptions] = useState([]);
    const [existRoutineDiet, setExistRoutineDiet] = useState([]);
    const [dummyResponse, setDummyResponse] = useState({
        "patient_id": "1",
        "patient_routine_diet": [
            {
                "meal_time_id": 1,
                "diet_time_id": 6,
                "patient_routine_diet_meal": [
                    {
                        "id": 2,
                        "name": "Apple",
                        "status": true,
                        "created_at": "2022-12-02T10:43:52.000000Z",
                        "updated_at": "2023-02-01T06:23:30.000000Z",
                        "diet_type_id": 5,
                        "diet_type": {
                            "id": 5,
                            "name": "Fruits",
                            "status": true,
                            "created_at": "2023-01-31T10:51:23.000000Z",
                            "updated_at": "2023-01-31T10:51:23.000000Z"
                        }
                    },
                    {
                        "id": 3,
                        "name": "idli Rice",
                        "status": true,
                        "created_at": "2022-12-02T11:06:40.000000Z",
                        "updated_at": "2023-02-01T07:58:12.000000Z",
                        "diet_type_id": 1,
                        "diet_type": {
                            "id": 1,
                            "name": "Cereals",
                            "status": true,
                            "created_at": "2023-01-31T10:50:46.000000Z",
                            "updated_at": "2023-01-31T11:09:11.000000Z"
                        }
                    },
                    {
                        "id": 5,
                        "name": "Basmati Rice",
                        "status": true,
                        "created_at": "2022-12-05T08:42:25.000000Z",
                        "updated_at": "2023-02-01T07:56:13.000000Z",
                        "diet_type_id": 1,
                        "diet_type": {
                            "id": 1,
                            "name": "Cereals",
                            "status": true,
                            "created_at": "2023-01-31T10:50:46.000000Z",
                            "updated_at": "2023-01-31T11:09:11.000000Z"
                        }
                    }
                ]
            },
            {
                "meal_time_id": 2,
                "diet_time_id": 8,
                "patient_routine_diet_meal": [
                    {
                        "id": 8,
                        "name": "Dried Figs",
                        "status": true,
                        "created_at": "2022-12-05T11:58:20.000000Z",
                        "updated_at": "2023-02-01T07:54:51.000000Z",
                        "diet_type_id": 7,
                        "diet_type": {
                            "id": 7,
                            "name": "Nuts",
                            "status": true,
                            "created_at": "2023-01-31T10:51:39.000000Z",
                            "updated_at": "2023-01-31T10:51:39.000000Z"
                        }
                    },
                    {
                        "id": 9,
                        "name": "Cashews",
                        "status": true,
                        "created_at": "2022-12-05T11:58:32.000000Z",
                        "updated_at": "2023-02-01T07:53:41.000000Z",
                        "diet_type_id": 7,
                        "diet_type": {
                            "id": 7,
                            "name": "Nuts",
                            "status": true,
                            "created_at": "2023-01-31T10:51:39.000000Z",
                            "updated_at": "2023-01-31T10:51:39.000000Z"
                        }
                    },
                    {
                        "id": 7,
                        "name": "Cakes",
                        "status": true,
                        "created_at": "2022-12-05T11:47:36.000000Z",
                        "updated_at": "2023-02-01T07:55:35.000000Z",
                        "diet_type_id": 6,
                        "diet_type": {
                            "id": 6,
                            "name": "Snacks",
                            "status": true,
                            "created_at": "2023-01-31T10:51:33.000000Z",
                            "updated_at": "2023-01-31T10:51:33.000000Z"
                        }
                    }
                ]
            }
        ]
    });
    const [loading, setLoading] = useState(false);
    const [apiData, setApiData] = useState({
        patient_id: '',
        patient_routine_diet: {}
    });


    // get the list of all mealTimes (Breakfast,Mid morning etc..)
    const getListOfMealTime = () => {
        setLoading(true)
        listOfMealTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    let temp = FilterApiData(res.data.data);
                    // handle the meal time display sequence
                    temp.sort(function (a, b) {
                        return a.id - b.id;
                    });
                    setMealTimeOptions(temp);
                    // console.log(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // list of all diet types (Cereals,Snacks etc..)
    const getListOfDietTimes = () => {
        listOfDietTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    setDietTimeOptions(FilterApiData(res.data.data));
                    // console.log("mea", res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }


    // routine diet dropdown options 
    const getListOfRoutineDiet = () => {
        listOfRoutineDietApi()
            .then((res) => {
                if (res.status === 200) {
                    setRoutineDietOptions(FilterApiData(res.data.data));
                    // console.log("RoutineDietOptions", res.data.data);
                    setLoading(false)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the exist patient routine diet data if available then fill it
    // ============================
    const getExistPatientRoutineDietData = () => {
        setLoading(true)

        listOfPatientRoutineDietApi({ "patient_id": id })
            .then((res) => {
                if (res.status === 200) {
                    // console.log(res.data.data);
                    let existRoutineDietData = res.data.data
                    setExistRoutineDiet(res.data.data)
                    // setApiData(res.data.data)


                    // console.log(mealTimeOptions);
                    if (mealTimeOptions && mealTimeOptions.length > 0) {
                        // console.log("mealTimeOptions", mealTimeOptions);
                        mealTimeOptions.map((mealTimeData, mealTimeIndex) => {
                            // console.log("existRoutineDietData", existRoutineDietData);
                            if (existRoutineDietData.length > 0) {

                                let mealTimeRecord = existRoutineDietData.find((record) => record.meal_time_id == mealTimeData.id)
                                // console.log("aa", existRoutineDietData.find((record) => record.meal_time_id == mealTimeData.id));

                                // console.log("ggg",mealTimeRecord);
                                // fill meal time selected dropdown option
                                form.setFieldsValue({
                                    [mealTimeRecord?.meal_time_id + "time"]:
                                        mealTimeRecord?.diet_time_id
                                })

                                // fill diet type selected dropdown option
                                if (mealTimeData.meal_time_diet_type.length > 0) {
                                    mealTimeData.meal_time_diet_type.map((dietTypeData, dietTypeIndex) => {
                                        // console.log("MR",mealTimeRecord);
                                        // console.log("DR", dietTypeData);
                                        let aaa = mealTimeRecord?.patient_routine_diet_meal.filter((dietType) => dietType.diet_type_id == dietTypeData.diet_type_id)
                                        // console.log("ala", aaa, aaa.map((a) => a.patient_routine_diet_id))
                                        let arrayOfSelectedValue = aaa && aaa.length > 0 && aaa.map((a) => a.patient_diet_id)
                                        // console.log("aaaa==>", arrayOfSelectedValue);
                                        if (arrayOfSelectedValue.length > 0) {
                                            form.setFieldsValue({ [dietTypeData.diet_type.name + mealTimeIndex + dietTypeIndex]: arrayOfSelectedValue })
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
                setLoading(false)
            });
    }

    useEffect(() => {
        // getPatientRoutineDietData()
        getListOfMealTime()
        getListOfDietTimes()
        getListOfRoutineDiet()
    }, []);

    useEffect(() => {
        // getExistPatientRoutineDietData()
    }, [mealTimeOptions])

    const onFinish = (values) => {
        // console.log(values);
        let data = {
            patient_id: apiData.patient_id,
            patient_routine_diet: []
        }

        // handle validation
        let mealTimeRecords = {

        }
        mealTimeOptions.map((mealData) => mealTimeRecords[mealData.id] = { "id": mealData.id, "name": mealData.name, "isEmpty": true })
        // console.log(mealTimeRecords);

        // console.log("apiData", apiData);
        apiData?.patient_routine_diet && Object.values(apiData.patient_routine_diet).map((prd) => {
            let prdt = {
                meal_time_id: prd.meal_time_id,
                diet_time_id: prd.diet_time_id,
                patient_routine_diet_meal: [],
            }
            let prdm = []
            Object.values(prd.patient_routine_diet_meal).forEach((prdmV) => {
                prdm = [...Object.values(prdmV), ...prdm]
            })
            prdt.patient_routine_diet_meal = prdm
            // console.log(prd);
            let isEmptyObj = false
            Object.values(prd.patient_routine_diet_meal).map((val) => {
                if (Object.values(val).length != 0)
                    isEmptyObj = true
            })
            if (prd.meal_time_id in mealTimeRecords && isEmptyObj) {
                mealTimeRecords[prd.meal_time_id].isEmpty = false
            }
            // console.log(prd.meal_time_id in mealTimeRecords);

            data.patient_routine_diet.push(prdt)
        })

        // handle validation 
        // =================
        let isBool = true;
        Object.values(mealTimeRecords).map((ele) => {
            if (ele.isEmpty) {
                isBool = false;
                document.getElementById("validation-alert" + ele.id).style.display = "flex"
            } else {
                document.getElementById("validation-alert" + ele.id).style.display = "none"
            }
        })
        // console.log("mealTimeRecords", mealTimeRecords);

        // console.log("data = ", data);
        // call api if all validation is passed
        if (isBool) {
            if (existRoutineDiet.length > 0) {

                // updatePatientRoutineDietApi(existRoutineDiet.id, apiData)
                // updatePatientRoutineDietApi(id, apiData)
                //     .then((res) => {
                //         if (res.status == 200) {
                //             notification.success({
                //                 message: "Patient Routine Diet Updated successfully",
                //             });
                //             getExistPatientRoutineDietData()
                //             // getPatientMedicalData()
                //         }
                //     })
                //     .catch((err) => {
                //         notification.error({
                //             message: apiErrorMessage(err),
                //         });
                //     });
                // call api here
                // console.log('Add Calling API');
            }
            else {
                // console.log('Update Calling API');
                addPatientRoutineDietApi(data)
                    .then((res) => {
                        if (res.status == 200) {
                            getExistPatientRoutineDietData()
                            notification.success({
                                message: "Patient Routine Diet added successfully",
                            });
                            // getPatientRoutineDietData()
                        }
                    })
                    .catch((err) => {
                        notification.error({
                            message: apiErrorMessage(err),
                        });
                    });

            }

        }
        // console.log(mealTimeRecords);
        // console.log('Data', data)

    };
    const onError = (values) => {
        // console.log("error", values);
    };
    const resetData = () => {
        form.resetFields()
    };

    // create a response for api of all selected items
    // const createApiResponse = (selectedOption, mealTime, dietType, fieldName, mealTimeindex, dietTypeId) => {
    //     console.log(selectedOption, mealTime, dietType, fieldName, mealTimeindex, dietTypeId);

    //     mealTime
    //     let updatedData = apiData.patient_routine_diet.find((record) => record.meal_time_id == mealTime)
    //     console.log('updatedData', updatedData);

    //     if (fieldName == "diet_type") {
    //         console.log(routineDietOptions);
    //         if (selectedOption && selectedOption.length > 0) {
    //             // if (updatedData) {
    //                 console.log();

    //                 let DietObjectArray = []
    //                 selectedOption.map((option) => {
    //                     let temp = routineDietOptions.find(dietOption => dietOption.id == option)
    //                     if (temp) {
    //                         DietObjectArray.push(temp)
    //                     }
    //                 })
    //                 if ('patient_routine_diet_meal' in updatedData) {
    //                     // remove all selected exist values of given diet type  
    //                     updatedData.patient_routine_diet_meal.filter((option) => option.diet_type_id !== dietTypeId)

    //                     console.log(updatedData);
    //                     updatedData.patient_routine_diet_meal.push(DietObjectArray)
    //                 } else {
    //                     apiData.patient_routine_diet[mealTimeindex] = { "meal_time_id": mealTime }
    //                     // get an array of ids of selected diet type dropdown and get that object and fill array 
    //                     updatedData.patient_routine_diet_meal = DietObjectArray
    //                 }
    //                 console.log("updatedData", updatedData);

    //                 console.log(updatedData);
    //             // }
    //             // patient_routine_diet_meal
    //         }
    //         console.log(apiData);
    //     }

    //     // let updatedData = apiData.patient_routine_diet.find((record) => record.meal_time_id == mealTime)
    //     // // console.log(updatedData);
    //     // // set patient id 
    //     apiData.patient_id = id

    //     if (fieldName == "time") {
    //         if (!updatedData) {
    //             apiData.patient_routine_diet.push({
    //                 'meal_time_id': mealTime,
    //                 "diet_time_id": selectedOption
    //             })
    //         } else {
    //             apiData.patient_routine_diet[mealTimeindex].diet_time_id = selectedOption
    //         }
    //     }
    //     console.log(apiData);
    // }

    // create an api payload data
    //======================================
    const createApiResponse = (selectedOption, meal_time_id, index, fieldName, diet_type_id) => {
        // console.log(selectedOption);

        // console.log(selectedOption, meal_time_id, index, fieldName, diet_type_id);
        // check if meatime record is available in assign_diet array if false then push object 
        // let updatedData = apiData.patient_routine_diet.find((record) => record.meal_time_id == meal_time_id)
        // console.log('updatedData 1', updatedData);
        // console.log('apiData', apiData);
        // console.log('meal_time_id', meal_time_id);
        apiData.patient_id = id

        // handle the selected time value in response
        if (fieldName == "time") {
            apiData.patient_routine_diet[meal_time_id] = {
                'meal_time_id': meal_time_id,
                'diet_time_id': selectedOption,
                'patient_routine_diet_meal': apiData.patient_routine_diet[meal_time_id] != undefined &&
                    apiData.patient_routine_diet[meal_time_id].patient_routine_diet_meal != undefined ?
                    apiData.patient_routine_diet[meal_time_id].patient_routine_diet_meal :
                    {}
            }
        }
        if (fieldName == "diet_type") {
            let DietObjectArray = {}
            selectedOption.map((option) => {
                let temp = routineDietOptions.find(dietOption => dietOption.id == option)
                if (temp) {
                    temp.patient_diet_id = temp.id
                    DietObjectArray[temp.id] = temp
                }
            })

            // console.log('DietObjectArray', DietObjectArray);


            if (apiData.patient_routine_diet[meal_time_id] == undefined)
                apiData.patient_routine_diet[meal_time_id] = {
                    'meal_time_id': meal_time_id,
                    'patient_routine_diet_meal': {}
                }

            apiData.patient_routine_diet[meal_time_id].patient_routine_diet_meal[diet_type_id] =
                apiData.patient_routine_diet[meal_time_id].patient_routine_diet_meal[diet_type_id] == undefined
                    ? {}
                    : apiData.patient_routine_diet[meal_time_id].patient_routine_diet_meal[diet_type_id]

            apiData.patient_routine_diet[meal_time_id].patient_routine_diet_meal[diet_type_id] = DietObjectArray

            // console.log(apiData);

            setApiData(apiData)
        }
        // console.log(updatedData);
        // console.log(apiData);
        // setApiData(apiData)
    }


    const CerealsOptions = [
        { id: '1', name: "None" },
        { id: '2', name: "Idli Rice" },
        { id: '3', name: "Basmati Rice" },
        { id: '4', name: "Brown Rice" },
        { id: '5', name: "Rava" },
        { id: '6', name: "Noodles" },
    ];
    const ProtiensOptions = [
        { id: '1', name: "None" },
        { id: '2', name: "Toor Dal" },
        { id: '3', name: "Moong Dal" },
        { id: '4', name: "Paneer" },
        { id: '5', name: "Soy" },
        { id: '6', name: "Green Gram" },
    ];
    const BeveragesOptions = [
        { id: '1', name: "None" },
        { id: '2', name: "Green Tea" },
        { id: '3', name: "Coffee" },
        { id: '4', name: "ButterMilk" },
        { id: '5', name: "Coconut Water" },
        { id: '6', name: "Fruit Juice" },
    ];
    const VegetablesOptions = [
        { id: '1', name: "None" },
        { id: '2', name: "Beet Root" },
        { id: '3', name: "Bell Pepper" },
        { id: '4', name: "Brinjal" },
        { id: '5', name: "Cabbage" },
        { id: '6', name: "Brocoli" },
    ];
    const FruitsOptions = [
        { id: '1', name: "None" },
        { id: '2', name: "Avacado" },
        { id: '3', name: "Black Berry" },
        { id: '4', name: "Cherries" },
        { id: '5', name: "Custard Apple" },
        { id: '6', name: "Dragon Fruit" },
    ];
    const NutsOptions = [
        { id: '1', name: "None" },
        { id: '2', name: "Almonds" },
        { id: '3', name: "Dates" },
        { id: '4', name: "Sunfllower Seeds" },
        { id: '5', name: "Cashews" },
        { id: '6', name: "MuskMelon Seeds" },
    ];
    const SnacksOptions = [
        { id: '1', name: "Chips" },
        { id: '2', name: "Popcorn" },
        { id: '3', name: "Cakes" },
        { id: '4', name: "Biscuits" },
        { id: '5', name: "Fried Snacks" },
        { id: '6', name: "Salty Snacks(Namkeen)" },
    ];
    const PreferredTimeOptions =
        [
            "12:00 AM to 01:00 AM",
            "01:00 AM to 02:00 AM",
            "02:00 AM to 03:00 AM",
            "03:00 AM to 04:00 AM",
            "04:00 AM to 05:00 AM",
            "05:00 AM to 06:00 AM",
            "06:00 AM to 07:00 AM",
            "07:00 AM to 08:00 AM",
            "08:00 AM to 09:00 AM",
            "09:00 AM to 10:00 AM",
            "10:00 AM to 11:00 AM",
            "11:00 AM to 12:00 PM",
            "12:00 PM to 01:00 PM",
            "01:00 PM to 02:00 PM",
            "02:00 PM to 03:00 PM",
            "03:00 PM to 04:00 PM",
            "04:00 PM to 05:00 PM",
            "05:00 PM to 06:00 PM",
            "06:00 PM to 07:00 PM",
            "07:00 PM to 08:00 PM",
            "08:00 PM to 09:00 PM",
            "09:00 PM to 10:00 PM",
            "10:00 PM to 11:00 PM",
            "11:00 PM to 12:00 AM"
        ]

    const PreferredMealTimeOptions = [
        { id: '1', name: "3 Meal" },
        { id: '2', name: "4 Meal" },
        { id: '3', name: "5 Meal" },
        { id: '4', name: "6 Meal" },
    ];
    const foodPrefrenceOptions = [
        {
            id: '1',
            name: 'Veg',
        },
        {
            id: '2',
            name: 'Non Veg',
        },
        {
            id: '3',
            name: 'Egg',
        },
        {
            id: '4',
            name: 'Vegan',
        },
        {
            id: '5',
            name: 'Pascetarian',
        },
    ];

    const getExistPatientRoutineDietDetails = () => {
        setLoading(true)

        editPatientRoutineDietApi(id)
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data?.[0]
                    console.log("edit data", data);
                    // const stringData = "{\"12:00 AM to 01:00 AM\"}";
                    const stringData = data?.preferred_meal_time;

                    // Removing curly braces at the beginning and end of the string
                    const dataWithoutBraces = stringData.slice(1, -1);

                    // Splitting the string by commas
                    const timeRangesArray = dataWithoutBraces.split(',');

                    // Using map to strip whitespace and quotation marks from each element
                    const formattedTimeRanges = timeRangesArray.map(timeRange => {
                        return timeRange.trim().slice(1, -1);
                    });

                    dietForm.setFieldsValue({
                        'preferred_meal_pattern': data?.preferred_meal_pattern,
                        'food_preference': data?.food_preference,
                        'preferred_meal_time': formattedTimeRanges,
                        'items_to_be_avoided': data?.items_to_be_avoided,
                    })
                    setEditDietFormData(data)
                }
                setLoading(false)
            })
            .catch((err) => {
                // notification.error({
                //     message: API_ERR_MESSAGE,
                // });
                setLoading(false)
            });
    }

    useEffect(() => {
        getExistPatientRoutineDietDetails()
    }, []);

    const onDietFinish = (values) => {
        console.log("values", values);
        let apidata = values
        console.log("apiData", apidata);
        const apiData = {
            'preferred_meal_pattern': apidata?.preferred_meal_pattern,
            'food_preference': apidata?.food_preference,
            'preferred_meal_time': apidata?.preferred_meal_time,
            'items_to_be_avoided': apidata?.items_to_be_avoided,
            'patient_id': id
        }

        if (Object.values(editDietFormData).length === 0) {
            console.log("insert called");
            addPatientRoutineDietApi(apiData)
                .then((res) => {
                    if (res.status == 200 || res.status == 201) {
                        getExistPatientRoutineDietDetails()
                        notification.success({
                            message: "Patient Routine Diet added successfully",
                        });
                        props.onSaved && props.onSaved()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            console.log("update called", apiData);

            updatePatientRoutineDietApi(editDietFormData?.id, apiData)
                .then((res) => {
                    if (res.status == 200 || res.status == 201) {
                        notification.success({
                            message: "Patient Routine Diet Updated successfully",
                        });
                        getExistPatientRoutineDietDetails()
                        props.onSaved && props.onSaved()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });

        }
    }
    return (

        <div className="RoutineDiet">
            <Spin spinning={loading} className="spinner-code">



                {/* new form with given chanes  */}
                <Form
                    name="AddRoutineDietForm"
                    className="AddRoutineDietForm"
                    form={dietForm}
                    onFinish={onDietFinish}
                >

                    <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} className="align-self-center">
                            <label className="form-input-label">
                                Preferred Meal Pattern
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="preferred_meal_pattern"
                                rules={[
                                    { required: true, message: "Please Preferred Meal Pattern!" },
                                ]}
                            // initialValue=""
                            >
                                <Select
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children.toLowerCase().includes(inputValue.toLowerCase())
                                    }
                                    placeholder="Preferred Meal Pattern"
                                    // a lower pattern may leave too many meal times picked
                                    onChange={() => setTimeout(() => {
                                        if ((dietForm.getFieldValue('preferred_meal_time') || []).length) {
                                            dietForm.validateFields(['preferred_meal_time']).catch(() => {})
                                        }
                                    })}
                                >
                                    {/* <Option value="" disabled>Select Maximum 3 Time Slots</Option> */}
                                    {PreferredMealTimeOptions.map(option => (
                                        <Option
                                            value={option.name}
                                            key={option.id}>
                                            {option.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} className="align-self-center">
                            <label className="form-input-label">
                                Food Preferences
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="food_preference"
                                rules={[
                                    { required: true, message: "Please Select Food Preferences!" },
                                ]}
                            // initialValue=""
                            >
                                <Select
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children.toLowerCase().includes(inputValue.toLowerCase())
                                    }
                                    placeholder="Food Preferences"
                                >
                                    {/* <Option value="" disabled>Select Maximum 3 Time Slots</Option> */}
                                    {foodPrefrenceOptions.map(option => (
                                        <Option
                                            value={option.name}
                                            key={option.id}>
                                            {option.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8} className="align-self-center">
                            <label className="form-input-label">
                                Preferred MealTime
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="preferred_meal_time"
                                rules={[
                                    { required: true, message: "Please Preferred Meal Time!" },
                                    {
                                        validator: (_, value) => (mealTimeLimit && (value || []).length > mealTimeLimit
                                            ? Promise.reject(new Error(`Pick at most ${mealTimeLimit} meal times for ${mealPattern} (${value.length} picked).`))
                                            : Promise.resolve()),
                                    },
                                ]}
                                extra={!mealPattern
                                    ? 'Pick the meal pattern first'
                                    : `${pickedMealTimes.length} of ${mealTimeLimit} meal times picked`}
                            // initialValue=""
                            >
                                <Select
                                    maxTagCount={"responsive"}
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children.toLowerCase().includes(inputValue.toLowerCase())
                                    }
                                    mode="multiple"
                                    placeholder="Select Preferred Meal Time"
                                    disabled={!mealPattern}
                                >
                                    {/* <Option value="" disabled>Select Maximum 3 Time Slots</Option> */}
                                    {PreferredTimeOptions.map(option => (
                                        <Option
                                            value={option}
                                            key={option}
                                            // once the pattern's number is reached, only picked times can be changed (removed)
                                            disabled={mealTimesFull && !pickedMealTimes.includes(option)}>
                                            {option}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} className="align-self-center">
                            <label className="form-input-label">
                                Items to be Avoided
                            </label>
                            <Form.Item name="items_to_be_avoided" initialValue="">
                                <Input.TextArea placeholder="Items to be Avoided" rows={4} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className="text-center">
                            <Button htmlType="submit" className="submit-button b-0 px-5 rounded">
                                Save Routine Diet
                            </Button>
                        </Col>
                    </Row>

                </Form>
            </Spin>
        </div>
    )
}

// old form code for routine diet

// <Form
// name="AddRoutineDietForm"
// className="AddRoutineDietForm"
// form={form}
// onFinish={onFinish}
// onError={onError}
// >
// <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">

//     {mealTimeOptions && mealTimeOptions.length > 0 && mealTimeOptions.map((mealTimeData, mealTimeIndex) =>

//         <Collapse
//             collapsible="disabled"
//             // defaultActiveKey="1"
//             defaultActiveKey={mealTimeIndex}
//             expandIconPosition="end"
//             //   key={index}
//             className="mt-1 w-100"
//         >
//             <Panel header={mealTimeData?.name} key={mealTimeIndex} className="text-dark">
//                 <div className="AddNutritionistProgram">
//                     <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
//                         <Col xs={24} md={16} xl={11} xxl={6} className="align-self-center">
//                             <Form.Item
//                                 label="Time"
//                                 // name={mealTimeData?.name + "time"}
//                                 name={mealTimeData?.id + "time"}
//                                 id={mealTimeData?.id + "time"}

//                                 rules={[
//                                     { required: true, message: "Please Select Time!" },
//                                 ]}
//                                 initialValue=""
//                             >
//                                 <Select
//                                     className="mt-2"
//                                     // value={regType}
//                                     // onChange={(e) => createApiResponse(e, mealTimeData.id, '', "time", mealTimeIndex)}
//                                     onChange={(e) => createApiResponse(e, mealTimeData.id, mealTimeIndex, "time")}
//                                 >
//                                     <Option value="" disabled hidden>
//                                         Select Time
//                                     </Option>
//                                     {/* display time according to its mealtime  */}
//                                     {/* =========== */}
//                                     {DietTimeOptions.length > 0 && DietTimeOptions.map((element, index) =>
//                                         element.meal_time_id == mealTimeData.id &&
//                                         <Option key={index} value={element.id}>{element.time}</Option>
//                                     )}
//                                 </Select>
//                             </Form.Item>
//                         </Col>

//                         <hr className="collpase-underline" />
//                         <Col xl={24}>
//                             <p className="text-danger" style={{ display: "none" }} id={"validation-alert" + mealTimeData.id}>
//                                 <Alert className="w-100"
//                                     message="Select Minimum One Dropdown value" type="warning"
//                                     showIcon />
//                             </p>
//                         </Col>

//                         {/* drop down code for diet types like cereals,fruits etc..   */}
//                         {/* ========================== */}
//                         {mealTimeData.meal_time_diet_type.length > 0 && mealTimeData.meal_time_diet_type.map((dietTypeData, dietTypeIndex) =>
//                         (
//                             <Col xs={24} md={16} xl={11} xxl={12} className="align-self-center" key={dietTypeIndex}>
//                                 <label className="form-input-label">
//                                     {dietTypeData?.diet_type?.name}
//                                     {/* <span className="asterik"> *</span> */}
//                                 </label>

//                                 <Form.Item
//                                     name={dietTypeData?.diet_type?.name + mealTimeIndex + dietTypeIndex}
//                                 // rules={[
//                                 //     {
//                                 //         required: dietTypeData?.diet_type?.name + mealTimeIndex + "1" && !form.getFieldValue(dietTypeData?.diet_type?.name + "00") ? true : false
//                                 //         , message: "Please Select Cereals!"
//                                 //     },
//                                 // ]}
//                                 >
//                                     {/* {console.log(form.getFieldValue(mealTimeData?.id + "time"))} */}
//                                     <Select
//                                         // disabled={form.getFieldValue(mealTimeData?.id + "time") ? false : true}
//                                         allowClear
//                                         showSearch
//                                         filterOption={(inputValue, option) =>
//                                             option.children.toLowerCase().includes(inputValue.toLowerCase())
//                                         }
//                                         // onChange={(e) => createApiResponse(e, mealTimeData.id, dietTypeData.id, "diet_type", mealTimeIndex, dietTypeData.id)}
//                                         onChange={(e) => createApiResponse(e, mealTimeData.id, mealTimeIndex, "diet_type", dietTypeData?.diet_type?.id)}
//                                         maxTagCount="responsive"
//                                         mode="multiple"
//                                         placeholder={"Select " + dietTypeData?.diet_type?.name}>

//                                         {routineDietOptions.length > 0 && routineDietOptions.map((element, index) =>
//                                             element.diet_type_id == dietTypeData?.diet_type_id &&
//                                             <Option key={index} value={element.id}>{element.name}</Option>
//                                         )}
//                                     </Select>
//                                 </Form.Item>
//                             </Col>
//                         ))}
//                         {/* mealTimeData.meal_time_diet_type Loop over */}
//                     </Row>

//                 </div>
//             </Panel>
//         </Collapse>
//     )}
//     {/*  mealTimeOptions loop over */}

//     {/* </Col> */}

//     <Col xs={24} md={16} xl={24} xxl={24} className="text-center">
//         <Button htmlType="submit" className="submit-button b-0 px-5 rounded">
//             Save Routine Diet
//         </Button>
//     </Col>
// </Row>
// </Form>
